import { render, staticRenderFns } from "./ReportBuilder.vue?vue&type=template&id=496b2cba&scoped=true"
import script from "./ReportBuilder.vue?vue&type=script&lang=ts"
export * from "./ReportBuilder.vue?vue&type=script&lang=ts"
import style0 from "./ReportBuilder.vue?vue&type=style&index=0&id=496b2cba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b2cba",
  null
  
)

export default component.exports